import { lazy } from 'react';

export const NftSecondaryMarketModalLazy = lazy(
    () => import(/* webpackChunkName: "NftSecondaryMarketModal" */ './NftSecondaryMarketModal.tsx')
);
